module.exports = __webpack_public_path__ + "static/2-c940451bc61bb31a4daf7f10fa65717d.jpg";